module.exports = __webpack_public_path__ + "img/hylei-8.fa562ce5.png";